import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { ReportDatatableModule } from '../../../shared/components/report-datatable/report-datatable.module';
import { ReportViewComponent } from './report-view.component';
import { ChartsModule } from 'ng2-charts';

@NgModule({
  declarations: [ReportViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ReportDatatableModule,
    ChartsModule
  ],
  exports: [ReportViewComponent]
})
export class ReportViewModule {}
